import {
	desktopSize,
	mobileSize,
} from '@components/filmstrip-carousel/constants';
import { MEDIA_QUERY_STATES } from '@constants/media-query';
import { useMedia } from '@tkww/orion-web-app-kernel';
import { useEffect, useMemo, useState } from 'react';

export const useSlideWidth = () => {
	const desktopMedia = useMedia('@desktop');
	// The server can't evaluate media queries, so it always renders the mobile
	// slide width. The first client render has to agree with it, otherwise the
	// carousel hydrates with a different visible slide count and React discards
	// the server markup.
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	return useMemo(() => {
		const isDesktop = isClient && desktopMedia === MEDIA_QUERY_STATES.matched;
		return isDesktop ? desktopSize : mobileSize;
	}, [desktopMedia, isClient]);
};
